import {API} from '@/typings/app';
import {getRequestInit, postFileRequestInit, postRequestInit} from './common/request-init';
const baseURL = VUE_APP_BASE_API;

// 微信初始化
const initWechatAPI: API = {
  url: baseURL.concat('/jop-web/wxinit/jsapi_ticketSign'),
  requestInit: postRequestInit,
};

// 首页信息
const homeInfoAPI: API = {
  url: baseURL.concat('/jop-web/wxosqtCat/lookShow'),
  requestInit: postRequestInit,
};

// 企业信息
const companyInfoAPI: API = {
  url: baseURL.concat('/jop-web/companyInfo/getCompanyInfo'),
  requestInit: postRequestInit,
};

// 新增留言
const addMessageAPI: API = {
  url: baseURL.concat('/jop-web/wxlw/postWebRecord'),
  requestInit: postRequestInit,
};

// 查询新闻详情
const newsDetailAPI: API = {
  url: baseURL.concat('/jop-web/wxosqt/selectOne'),
  requestInit: postRequestInit,
};

// 查询新闻列表
const newsListAPI: API = {
  url: baseURL.concat('/jop-web/wxosqt/lookByPage'),
  requestInit: postRequestInit,
};

// 查询留言页面背景
const messageBackgroundAPI: API = {
  url: baseURL.concat('/jop-web/wxlw/qryWxblw'),
  requestInit: postRequestInit,
};

export {
  homeInfoAPI,
  companyInfoAPI,
  addMessageAPI,
  newsDetailAPI,
  newsListAPI,
  messageBackgroundAPI,
  initWechatAPI,
};
